import { Injectable, Inject } from '@angular/core';

export class QuotationCoverageInsuredDiscountDO {

	private id: Number;

	public discoutType: Number = 0.0;
	public discountValue: Number = 0.0;
	public discountReason: Number = 0.0;
	public discoutPremium: Number = 0.0;


	public getId(): Number {
		return this.id;
	}


}